import { Analytics } from '@payu/paymentsos-types'

export default function convertRawDataToTabContentData (data: Analytics.AnalyticsResponse, metric: Analytics.Metric['name']): null | Record<string, number> {
  return dataIsEmpty(data) ? null : mapRawDataToTabContentData(data, metric)
}

function mapRawDataToTabContentData (data: Analytics.AnalyticsResponse, metric: Analytics.Metric['name']): Record<string, number> {
  return data.buckets
    .map((bucket: Analytics.Bucket) => bucket.data.reduce(createBucketDataReducer(metric), {}))[0]
}

function createBucketDataReducer (metric: Analytics.Metric['name']) {
  return function bucketDataReducer (
    entity: Record<string, number>,
    bucketData: Analytics.ResponseItem
  ): Record<string, number> {
    if (bucketData.dimensions) {
      const value = Object.values(bucketData.dimensions)[0] as string
      if (value) {
        entity[value] = bucketData.metrics[metric] as number
      }
    }
    return entity
  }
}

function dataIsEmpty (data: Analytics.AnalyticsResponse): boolean {
  return !(data?.buckets?.[0]?.data?.length > 0)
}
